import React, { useState } from 'react';
import Modal from "../../../components/molecules/Modal"
import moment from 'moment';
import DatePicker from "react-datepicker";
import { prop } from 'lodash/fp';

const ModalCalendar = props => {
    let someDate = new Date();
    const multiplier = 86400000;
    const [ date, setDate ] = useState({
        from:new Date(new Date().getTime() - parseInt(30*multiplier)),
        to:new Date(new Date().getTime() + parseInt(1*multiplier))
    })
    const onSetDate = (type,d) => {
        if (type === 'from') {
            setDate({...date, from:d})    
        } else {
            setDate({...date, to:d})
        }
    };

    const onHide = () => {
        if (moment(date.from).isAfter(date.to)){
            alert("Tanggal awal tidak bisa setelah tanggal akhir")
            return
        }
        
        if (moment(date.to).isBefore(date.from)){
            alert("Tanggal akhir tidak bisa sebelum tanggal awal")
            return
        }

        if (moment(date.from).diff(moment(date.to), 'days') < -90) {
            alert("Tidak bisa memilih lebih dari 90 hari")
            return
        }
        props.onHide(date.from,date.to)
    }

    const onSelectDates = () => {
        props.buttonClick(date.from,date.to)
    };

    return (
        <Modal
            show={props.show}
            onHide={onHide}
            title={props.title || "Tanggal Pengiriman"}
            size={"sm"}
            bodyClassName="py-4"
            loading={props.loading}
            buttons={props.buttons}
            type={props.type}
            bText={props.buttonText}
            bClick={onSelectDates}
        >
            <div className="form-row">
                <div className="col-6">
                    <label>Tanggal Awal</label>
                    <DatePicker
                        className="form-control mb-0"
                        onChange={e => onSetDate('from',e)}
                        selected={date.from}
                    />
                </div>
                <div className="col-6">
                    <label>Tanggal Akhir</label>
                    <DatePicker
                        className="form-control mb-0"
                        onChange={e => onSetDate('to',e)}
                        selected={date.to}
                    />
                </div>
            </div>
         
        </Modal>
    )
};

export default ModalCalendar